module.exports = __webpack_public_path__ + "img/logo.dfc6e77f.png";